import RestService from '@/common/RestService'
import { CABA1030ResponseModel } from '@/api/data/CAB/CABA1030/CABA1030ResponseModel'
import { CABA1031RequestModel } from '@/api/data/CAB/CABA1031/CABA1031RequestModel'
import { CABA1031ResponseModel } from '@/api/data/CAB/CABA1031/CABA1031ResponseModel'
import ApiUrlConstants from '@/common/ApiUrlConstants'

export default class CABG1030Service {
  private caba1031RequestModel = new CABA1031RequestModel()
  /**
   * function call CABA1030 API
   * @returns caba1030ResponseModel
   */
  public async callAPICABA1030(): Promise<CABA1030ResponseModel> {
    const caba1030ResponseModel: CABA1030ResponseModel = <
      CABA1030ResponseModel
    > await RestService.post(ApiUrlConstants.CABA1030, {})
    return caba1030ResponseModel
  }

  /**
   * function call CABA1031 API\
   * @returns caba1031ResponseModel
   */
  public async callAPICABA1031(): Promise<CABA1031ResponseModel> {
    const caba1031ResponseModel: CABA1031ResponseModel = <
      CABA1031ResponseModel
    > await RestService.post(ApiUrlConstants.CABA1031, this.caba1031RequestModel)
    return caba1031ResponseModel
  }
}
